import React, { useState } from 'react';
import Vimeo, { EndEvent, LoadEvent } from '@u-wave/react-vimeo';
import { useSearchParams } from 'react-router-dom';


const VideoPageLoop = () => {
  const [searchParams] = useSearchParams();
  const videoIdsParam = searchParams.get('videoIds');

  const videoIds = videoIdsParam ? videoIdsParam.split(',') : [];

  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const handleVideoEnd = (event: EndEvent) => {
    setCurrentVideoIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      return nextIndex < videoIds.length ? nextIndex : 0; // Loop back to the first video if needed
    });
  };

  const handleVideoLoaded = (event: LoadEvent) => {
    console.log('Video loaded');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-xl w-full shadow-lg rounded-lg bg-white p-6">
        <h1 className="text-2xl font-bold text-center mb-4">
          Video one after the other
        </h1>
        <h1 className="text-2xl font-bold text-center mb-4">
          Currently playing video {currentVideoIndex + 1}
        </h1>
        <div className="aspect-w-16 aspect-h-9">
          {videoIds.length > 0 && (
            <Vimeo
              video={videoIds[currentVideoIndex]}
              autoplay={true}
              onLoaded={handleVideoLoaded}
              onEnd={handleVideoEnd}
              onPause={(event) => console.log('Video paused')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoPageLoop;

// http://localhost:4200/loop?videoIds=860027142,862503509,862254320,855607201
